import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class ReceivingEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'numericMinValue',
			value => {
				return 1 / value > 0;
			},
			'NUMERICMINVALUE'
		);
		Validator.register(
			'notZero',
			value => {
				return value != 0;
			},
			'NOTZEROVALUE'
		);
		Validator.register(
			'notDecimal',
			value => {
				return !value.toString().includes('.');
			},
			'NOTDECIMALVALUE'
		);
		return {
			fields: [
				'seller',
				'warehouseFrom',
				'warehouseTo',
				'ref',
				'estimatedReceivingDate',
				'actualReceivingDate',
				'receivingStatus',
				'receivingType',
				'cost',
				'products',
				'products[].id',
				'products[].quantity',
				'products[].description',
				'products[].selectedProduct',
				'products[].isReceived',
			],
			labels: {
				seller: 'CONTAINERFORM.SELLER',
				warehouseFrom: 'CONTAINERFORM.WAREHOUSEFROM',
				warehouseTo: 'CONTAINERFORM.WAREHOUSETO',
				ref: 'CONTAINERFORM.REF',
				estimatedReceivingDate: 'CONTAINERFORM.ESTIMATEDRECEIVINGDATE',
				receivingStatus: 'CONTAINERFORM.RECEIVINGSTATUS',
				receivingType: 'CONTAINERFORM.RECEIVINGTYPE',
				actualReceivingDate: 'CONTAINERFORM.ACTUALRECEIVINGDATE',
				cost: 'CONTAINERFORM.COST',
				'products[].selectedProduct': 'CONTAINERFORM.PRODUCT',
				'products[].quantity': 'CONTAINERFORM.QUANTITY',
				'products[].description': 'CONTAINERFORM.DESCRIPTION',
			},
			rules: {
				receivingStatus: 'required',
				ref: 'required',
				estimatedReceivingDate: 'required',
				receivingType: 'required',
				'products[].selectedProduct': 'required',
				'products[].quantity': 'required|numeric|numericMinValue|notZero|notDecimal',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/receiving/forms/ReceivingEditForm.js